module.exports = __webpack_public_path__ + "static/UBC-68b24c5bb4a885524fff3d0efb182357.png";